import Actions from '../../odata/actions';

const actions = new Actions('fleetSupplier', 'fleetSuppliers');

export default actions;
